export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nehmer"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ersteller"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nehmer ID"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ersteller ID"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sie zahlen"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sie erhalten"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wartezeit"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bankkonto/Wallet"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beschreibung"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein Bankname"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein Bankkonto"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein Name angegeben"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein Konto angegeben"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extern"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intern"])}
}